const SettlementWarning = () => (
  <div className="small text-muted">*May exclude recent settlements</div>
);

export default SettlementWarning;
